import axios from "axios";
import { 
  alertMessages, 
  auditLogClimQuery, 
  getDeadCatalogs, 
  getDroughtCatalogs, 
  getFuelModelCatalogs,
  getLiveCatalogs
} from "src/constants";
import { errorResponse } from "src/store/common";
import { configurationClimatology } from "./getWeatherCalls";
import { configMutationClimatology } from "./mutationsApiKey";

export const getAuditItemsFromClim = async (request: any, addAlert: any) => {
  try {
    let dataAudit = JSON.stringify({
      query: auditLogClimQuery,
      variables: request
    });
    let config = configMutationClimatology(dataAudit, null);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const auditItems = response.data.data.getAuditTrailItems;
              return resolve(auditItems);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.getAuditLog);
            return reject(new Error(error))
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};

export const getFuelCatalogs = async (request: any, addAlert: any) => {
  try {
    let dataFuelModelCatalogs = JSON.stringify({
      query: getFuelModelCatalogs,
      variables: request
    });
    let config = configurationClimatology(dataFuelModelCatalogs);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const fuelModelCatalogs = response.data.data.getFuelModelCatalog;
              return resolve(fuelModelCatalogs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.retrieveCatalog);
            return reject(new Error(error))
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};


export const getDeadCatalogsCall = async (request: any, addAlert: any) => {
  try {
    let dataDeadCatalogs = JSON.stringify({
      query: getDeadCatalogs,
      variables: request
    });
    let config = configurationClimatology(dataDeadCatalogs);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const fuelModelCatalogs = response.data.data.getDeadFuelCatalog;
              return resolve(fuelModelCatalogs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.retrieveCatalog);
            return reject(new Error(error))
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};

export const getDroughtCatalogCall = async (request: any, addAlert: any) => {
  try {
    let dataDroughtCatalogs = JSON.stringify({
      query: getDroughtCatalogs,
      variables: request
    });
    let config = configurationClimatology(dataDroughtCatalogs);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const droughtCatalogs = response.data.data.getDroughtCatalogs;
              return resolve(droughtCatalogs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.retrieveCatalog);
            return reject(new Error(error))
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};

export const getLiveCatalogCall = async (request: any, addAlert: any) => {
  try {
    let dataLiveCatalogs = JSON.stringify({
      query: getLiveCatalogs,
      variables: request
    });
    let config = configurationClimatology(dataLiveCatalogs);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(function (response: any) {

            if (response.data.errors && response.data.errors.length > 0) {
              return reject(new Error(response.data.errors));
            } else {
              const droughtCatalogs = response.data.data.getLiveFuelCatalog;
              return resolve(droughtCatalogs);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.retrieveCatalog);
            return reject(new Error(error))
          });
      })
    );

  }
  catch (error) {
    console.log('error', error);

  }
};